import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../Translations';
import clsx from 'clsx';

const NoActiveProductLicenses: React.FC = () => (
  <div className="drop-shadow">
    <div
      className={clsx(
        'mb-6 w-full rounded-md border border-solid',
        'border-teal-400 bg-teal-500 bg-opacity-25 p-6',
      )}
    >
      <h3 className="text-base font-medium">
        <T kind="Unlicensed" />
      </h3>
      <p className="pt-2.5 text-sm">
        <T kind="A valid product license is required to build ..." />
      </p>
    </div>
  </div>
);

export default observer(NoActiveProductLicenses);
